const $ = require('cash-dom');

const GAEvents = {

    parseUrl: function (url) {
        var parser = document.createElement('a');
        parser.href = url;

        return parser;
    },

    trackClick: function ($obj) {
        $obj = $($obj);

        var href;
        if ($obj.data('href') === 'undefined') {
            href = $obj.data('href');
        } else {
            href = $obj.attr('href');
        }

        if (typeof href === 'undefined') {
            return;
        }

        //CATEGORY
        let category = $obj.data('ga-category');

        if (!category) {
            category =  $obj.data('btn-name');
        }

        if (!category) {
            category = this.getPageName(window.location.href);
        }

        if (!category) {
            return;
        }

        //ACTION
        let action = $obj.data('ga-event');

        if (!action) {
            action = ($obj.attr('target') && $obj.attr('target') === '_blank') ? 'click out' : 'click in';

            if (action === 'click in' && (href.indexOf('http:') === 0 || href.indexOf('https:') === 0)) {
                let hostname = this.parseUrl(href).hostname;

                if (hostname.indexOf('safetydetective.') === -1 && hostname.indexOf('safetydetectives.') === -1) {
                    action = 'click out';
                }
            }
        }

        //LABEL
        var label = $obj.data('ga-label');

        if (typeof label === 'undefined') {
            label = $obj.attr('title');
        }

        if (typeof label === 'undefined') {
            label = $obj.attr('data-title');
        }

        if (typeof label === 'undefined') {
            label = $obj.text().trim();
        }
        let nonInteraction = $obj.attr('data-ni');
        //go/vendor click out tracking in go-vendor routes
        //if (href.indexOf('go/vendor') >= 0 && category === 'click out') {
        //    return;
        //}

        this.sendEvent(category, action, label, nonInteraction);
    },

    sendEvent: function (category, action, label, nonInteraction) {
        nonInteraction = typeof nonInteraction === "undefined" ? false : true;

        let param = {
            event_category: category,
            event_label: label,
        };

        if (nonInteraction) {
            param.non_interaction = true;
        }

        if (document.body.classList.contains('logged-in') ||
          (typeof window.location.hash !== 'undefined' && window.location.hash === '#debug-events'))
        {
            console.log('GA Action: ' + action);
            console.log(param);
        }

        if (window.location.host.indexOf('.com') !== -1) {
            if (typeof gtag !== "undefined") {
                gtag('event', action, param);
            }
        }
    },

    getPageName: function (url) {
        var name, subpage;
        var aUrl = url.split('/');

        if (url.indexOf('http:') === 0 || url.indexOf('https:') === 0) {
            var hostname = this.parseUrl(url).hostname;

            if (hostname.indexOf('safetydetective.') === -1 && hostname.indexOf('safetydetectives.') === -1) {
                return '3rd party website';
            }

            name = aUrl[3];
            subpage = typeof aUrl[4] !== 'undefined' ? aUrl[4] : '';
        } else {
            name = aUrl[1];
            subpage = typeof aUrl[2] !== 'undefined' ? aUrl[2] : '';
        }

        if (typeof name === 'undefined' || name === '') {
            return 'homepage';
        }


        if (subpage !== '') {
            switch (name) {
                case 'blog':
                    if (subpage !== 'tags' && subpage !== 'page') {
                        name = 'blog-post';
                    }
                    break;

                case 'best-antivirus':
                    if (subpage !== 'windows' && subpage !== 'linux' && subpage !== 'mac' && subpage !== 'android' && subpage !== 'ios') {
                        name = 'vendor';
                    }
                    break;
                case 'best-password-managers':
                    if (subpage !== 'windows' && subpage !== 'linux' && subpage !== 'mac' && subpage !== 'android' && subpage !== 'ios') {
                        name = 'vendor';
                    }
                    break;
                case 'go':
                    if (subpage === 'product') {
                        name = 'go-product';
                    }
                    break;
            }
        }

        return name;
    },

    getPrefix: function ($obj) {
        var prefix = '';

        if (typeof $obj.attr('data-ga-prefix') !== 'undefined' && $obj.attr('data-ga-prefix').length) {
            prefix = $obj.attr('data-ga-prefix') + ': ';
        } else if ($obj.hasClass('page-numbers')) {
            prefix = 'pagination: ';
        } else if ($obj.parent().hasClass('nav-item')) {
            prefix = 'menu: ';
        } else if ($obj.closest('#breadcrumbs').length > 0) {
            prefix = 'breadcrumbs: ';
        }

        return prefix;
    },

    getSuffix: function ($obj) {
        var suffix = '';

        if (typeof $obj.attr('data-ga-suffix') !== 'undefined' && $obj.attr('data-ga-suffix').length) {
            suffix = ' (' + $obj.attr('data-ga-suffix') + ')';
        } else if ($obj.closest('[data-popup-id]').length > 0) {
            suffix = ' (' + $obj.closest('[data-popup-id]').data('popup-id') + ')';
        } else if ($obj.closest('#colorbox').length > 0) {
            suffix = ' (popup)';
        } else if ($obj.closest('aside').length > 0) {
            suffix = ' (sidebar)';
        }

        return suffix;
    },

    getObjType: function ($obj) {
        var type = '';

        if ($obj.hasClass('btn')) {
            type = ' (button)';
        } else {
            var $img = $obj.find('img').first();
            if ($img.length > 0) {
                if ($img.attr('src').indexOf('avatar') !== -1) {
                    type = ' (avatar)';
                } else {
                    type = ' (image)';
                }
            }
        }

        return type;
    }
};

$(function () {
    setTimeout(function () {
        $(document).on('click', 'a,div[data-ga-event]', function () {
            GAEvents.trackClick($(this));
        });

        //404 GA event report
        if ($('body.error404').length > 0) {
            var label = '';
            if (window.location.pathname) {
                label = window.location.pathname;
            }

            if (label.length > 40) {
                label = label.substr(0, 35) + '...';
            }

            GAEvents.sendEvent('error', '404', label)
        }
    }, 200);


    let sentEvents = [],
      ticking = false;

    window.addEventListener('scroll', function (e) {
        if (ticking) {
            return;
        }

        ticking = true;
        let pos = getScrollYPosition() + window.innerHeight,
          height = document.documentElement.scrollHeight,
          ratio = pos / height * 100;

        if (ratio < 25) {
            ticking = false;
            return;
        }

        let metricName;
        let scroll;
        if (ratio >= 90) {
            metricName = 'metric4';
            scroll = 90;
        } else if (ratio >= 75) {
            metricName = 'metric3';
            scroll = 75;
        } else if (ratio >= 50) {
            metricName = 'metric2';
            scroll = 50;
        } else {
            metricName = 'metric1';
            scroll = 25;
        }

        if (sentEvents.indexOf(scroll) !== -1) {
            ticking = false;
            return;
        }
        sentEvents.push(scroll);

        let params = {};
        params[metricName] = 1;

        gtag("set", params);

        GAEvents.sendEvent('Scroll tracking', 'Scroll ' + scroll + '%', document.title, true);
        ticking = false;
    }, {passive: true});

    function getScrollYPosition() {
        let supportPageOffset = window.pageYOffset !== undefined;
        let isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");

        return supportPageOffset
          ? window.pageYOffset
          : (isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop);
    }
});

window.GAEvents = GAEvents;
module.exports = GAEvents;
